"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _loading = require("@/mixins/loading/loading");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _permission = require("@/mixins/permission/permission");

var _elementUi = require("element-ui");

var _ganttFilter = _interopRequireDefault(require("@/views/milk-run/components/gantt-filter/gantt-filter.vue"));

var _ganttChart = _interopRequireDefault(require("@/views/milk-run/components/gantt-chart/gantt-chart.vue"));

var _countdown = _interopRequireDefault(require("@/components/countdown/countdown.vue"));

var _moment = _interopRequireDefault(require("moment"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRMainDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRMainDashboardComponent, _Mixins);

  var _super = _createSuper(MRMainDashboardComponent);

  function MRMainDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRMainDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.isEnableAllTrucks = true;
    _this.initAutoAddedDays = 0;
    _this.timeStepper = 30;
    _this.startDate = null;
    _this.endDate = null;
    _this.routeViewOptions = ['plannedRoutes', 'actualRoutes'];
    _this.planViewType = 'daily';
    _this.currentPlanId = null;
    _this.gcHeight = 400;
    _this.oldGCHeight = 400;
    _this.refreshTime = 30; // seconds

    _this.gcFilterHeight = 40;
    _this.isPlay = true;
    _this.isPause = false;
    return _this;
  }

  (0, _createClass2.default)(MRMainDashboardComponent, [{
    key: "onFSChanges",
    value: function onFSChanges(newVal) {
      if (newVal) {
        this.gcHeight = window.innerHeight - this.gcFilterHeight;
      } else {
        this.gcHeight = this.oldGCHeight - this.gcFilterHeight;
      }
    }
  }, {
    key: "containerStyles",
    get: function get() {
      return {
        height: !this.$isFullscreen ? 'calc(100vh - 60px)' : '100%'
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {}
  }, {
    key: "created",
    value: function created() {
      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }

      this.refreshTime = parseInt(this.helper.get(this.$userSetting, 'default14', 30), 10);
      this.startDate = (0, _moment.default)(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
      this.endDate = (0, _moment.default)(new Date()).add(1, 'days').format('YYYY-MM-DD');
      this.$planDateRange = [this.startDate, this.endDate];
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var containerEl, countdownEl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerEl = this.helper.get(this.$refs, 'container', null);

                if (containerEl) {
                  this.gcHeight = containerEl.clientHeight - this.gcFilterHeight;
                  this.oldGCHeight = containerEl.clientHeight;
                }

                countdownEl = this.helper.get(this.$refs, 'countdown', null);

                if (!countdownEl) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this.$getTrucks();

              case 6:
                _context.next = 8;
                return this.$initPlan();

              case 8:
                countdownEl.startTimer();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }() // hacked should use socket

  }, {
    key: "handleCountdownZero",
    value: function () {
      var _handleCountdownZero = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$initPlan();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleCountdownZero() {
        return _handleCountdownZero.apply(this, arguments);
      }

      return handleCountdownZero;
    }()
  }, {
    key: "handleEnableAllTrucks",
    value: function handleEnableAllTrucks() {
      this.isEnableAllTrucks = true;
    }
  }, {
    key: "handleDisableAllTrucks",
    value: function handleDisableAllTrucks() {
      this.isEnableAllTrucks = false;
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.timeStepper = newVal;
    }
  }, {
    key: "handleRouteViewsChanges",
    value: function handleRouteViewsChanges(newVal) {
      this.routeViewOptions = newVal;
    }
  }, {
    key: "handleGCPlay",
    value: function handleGCPlay() {
      this.isPlay = true;
      this.isPause = false;
    }
  }, {
    key: "handleGCPause",
    value: function handleGCPause() {
      this.isPlay = false;
      this.isPause = true;
    }
  }]);
  return MRMainDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MRMainDashboardComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], MRMainDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MRMainDashboardComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRMainDashboardComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$isFullscreen')], MRMainDashboardComponent.prototype, "onFSChanges", null);
MRMainDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRMainDashboardComponent',
  components: {
    'gantt-filter': _ganttFilter.default,
    'gantt-chart': _ganttChart.default,
    'countdown': _countdown.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col
  }
})], MRMainDashboardComponent);
var _default = MRMainDashboardComponent;
exports.default = _default;